export const mockHHAccounts = [
  { id: 'hh1', name: 'HR.Starec (Основной)', auth_state: 'connected', last_sync: '2025-06-15T08:00:00Z', vacancies_count: 3 },
  { id: 'hh2', name: 'HR.Starec (Тестовый)', auth_state: 'disconnected', last_sync: null, vacancies_count: 0 },
];

import type { Member } from '@/types';

export const mockMembers: Member[] = [
  { id: 'm1', name: 'Анна Сидорова', email: 'anna@starec.ai', role: 'org_admin', avatar: 'А', joined_at: '2024-01-15T10:00:00Z', status: 'active' },
  { id: 'm2', name: 'Игорь Михайлов', email: 'igor@starec.ai', role: 'hr_manager', avatar: 'И', joined_at: '2024-03-20T09:00:00Z', status: 'active' },
  { id: 'm3', name: 'Екатерина Волкова', email: 'katya@starec.ai', role: 'recruiter', avatar: 'Е', joined_at: '2024-05-10T11:00:00Z', status: 'active' },
  { id: 'm4', name: 'Павел Новиков', email: 'pavel@starec.ai', role: 'viewer', avatar: 'П', joined_at: '2024-08-01T14:00:00Z', status: 'pending' },
  { id: 'm5', name: 'Светлана Орлова', email: 'svetlana@starec.ai', role: 'recruiter', avatar: 'С', joined_at: '2025-01-12T08:30:00Z', status: 'active' },
];

export const mockOrganizations = [
  { id: 'o1', name: 'Starec AI', members_count: 5, vacancies_count: 4, candidates_count: 42, created_at: '2024-01-10T10:00:00Z' },
  { id: 'o2', name: 'Starec AI (Тест)', members_count: 2, vacancies_count: 1, candidates_count: 7, created_at: '2024-06-15T12:00:00Z' },
  { id: 'o3', name: 'TechStart Inc.', members_count: 8, vacancies_count: 6, candidates_count: 128, created_at: '2023-09-01T09:00:00Z' },
];

export const roleLabels: Record<Member['role'], string> = {
  super_admin: 'Супер-админ',
  org_admin: 'Администратор',
  hr_manager: 'Заказчик',
  recruiter: 'Рекрутер',
  viewer: 'Наблюдатель',
};

export const roleColors: Record<Member['role'], string> = {
  super_admin: 'bg-primary-100 text-primary-800',
  org_admin: 'bg-accent-100 text-accent-800',
  hr_manager: 'bg-secondary-100 text-secondary-800',
  recruiter: 'bg-primary-50 text-primary-700',
  viewer: 'bg-background-100 text-foreground-500',
};

export const mockDashboardStats = {
  total_vacancies: 4,
  active_vacancies: 3,
  total_candidates: 42,
  new_candidates_week: 12,
  avg_resume_score: 74,
  avg_total_score: 198,
  pending_interviews: 5,
};

export const mockRecentActivity = [
  { id: 'a1', type: 'candidate_import', text: 'Импортировано 7 откликов с hh.ru на вакансию Senior Frontend Developer', time: '2025-06-15T08:30:00Z' },
  { id: 'a2', type: 'scoring', text: 'AI-скоринг резюме: Александр Петров — 87/100', time: '2025-06-14T16:20:00Z' },
  { id: 'a3', type: 'email', text: 'Отправлена анкета кандидату Мария Иванова', time: '2025-06-14T09:00:00Z' },
  { id: 'a4', type: 'scoring', text: 'AI-скоринг совместимости: Елена Васильева — 85/100', time: '2025-06-13T14:10:00Z' },
  { id: 'a5', type: 'status_change', text: 'Дмитрий Соколов перенесён в статус "Резюме оценено"', time: '2025-06-12T11:45:00Z' },
  { id: 'a6', type: 'candidate_import', text: 'Импортировано 3 отклика с hh.ru на вакансию Product Manager', time: '2025-06-11T10:00:00Z' },
];